import { ActionType, getType } from 'typesafe-actions';

import * as bulkUploaderActions from './action';

type BulkUploaderActionType = ActionType<typeof bulkUploaderActions>;

export interface BulkUploaderState {
  downloadTradeTemplateLoading: boolean;
  uploadTradeTemplateLoading: boolean;
}

const initialState: BulkUploaderState = {
  downloadTradeTemplateLoading: false,
  uploadTradeTemplateLoading: false,
};

const bulkUploaderReducer = (
  state: BulkUploaderState = initialState,
  action: BulkUploaderActionType,
): BulkUploaderState => {
  switch (action.type) {
    // Download Trade Template
    case getType(bulkUploaderActions.getDownloadTradeTemplate.request):
      return {
        ...state,
        downloadTradeTemplateLoading: true,
      };
    case getType(bulkUploaderActions.getDownloadTradeTemplate.success):
      return {
        ...state,
        downloadTradeTemplateLoading: false,
      };
    case getType(bulkUploaderActions.getDownloadTradeTemplate.failure):
      return {
        ...state,
        downloadTradeTemplateLoading: false,
      };

    // Upload Trade Template
    case getType(bulkUploaderActions.getUploadTradeTemplate.request):
      return {
        ...state,
        uploadTradeTemplateLoading: true,
      };
    case getType(bulkUploaderActions.getUploadTradeTemplate.success):
      return {
        ...state,
        uploadTradeTemplateLoading: false,
      };
    case getType(bulkUploaderActions.getUploadTradeTemplate.failure):
      return {
        ...state,
        uploadTradeTemplateLoading: false,
      };

    default:
      return state;
  }
};

export default bulkUploaderReducer;
